module.exports = __webpack_public_path__ + "static/footerlogo-996d0a70116cd896be2550d0cb0ed9c5.png";